import axios from 'axios'

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '',
  headers: {
    'Content-Type': 'application/json',
  },
  // Serialise array query params as repeated keys (?key=A&key=B) so ASP.NET
  // Core's [FromQuery] binder picks them up. Axios's default emits
  // ?key[]=A&key[]=B, which the binder doesn't recognise for IReadOnlyList<T>.
  paramsSerializer: { indexes: null },
})

apiClient.interceptors.request.use(async (config) => {
  if (window.Clerk?.session) {
    const token = await window.Clerk.session.getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
  }
  return config
})

export default apiClient
